<template>
    <ul class="domestic-organization">
        <li v-for="(item, index) in items" :key="index">
            <v-row class="row--xxs">
                <v-col cols="12">
                    <v-sheet color="primary" outlined rounded="pill" class="px-16 py-8">
                        <h4 class="tit tit--sm primary--text line-height-1">
                            {{ item.type }}
                        </h4>
                    </v-sheet>
                </v-col>
                <v-col v-for="(child, index) in item.children" :key="index" cols="12">
                    <v-sheet min-height="70" color="#fafafa" class="domestic-organization__child">
                        <v-row align="center" class="page-text page-text--lg">
                            <v-col cols="10" lg="3" order="1" class="domestic-organization__name">{{ child.name }}</v-col>
                            <v-col cols="12" lg="3" order="3" class="domestic-organization__tel">
                                {{ child.tel }}
                            </v-col>
                            <v-col cols="12" lg="" order="4" class="domestic-organization__address">
                                {{ child.address }}
                            </v-col>
                            <v-col v-if="child.link" cols="2" lg="auto" order="2" order-lg="5" class="domestic-organization__link">
                                <v-btn :href="child.link" target="_blank" icon text>
                                    <v-img src="/images/about/organization/icon-home.svg" max-width="24" alt="홈페이지로 이동" />
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-col>
            </v-row>
        </li>
    </ul>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    type: "아동보육",
                    children: [
                        {
                            name: "대흥어린이집",
                            tel: "02-3273-7859",
                            address: "서울시 마포구 백범로79",
                            link: "https://cafe.naver.com/kid2",
                        },
                        {
                            name: "서초구립 포레스타2단지 어린이집",
                            tel: "02-576-7979",
                            address: "서울시 서초구 헌릉로 8길 45 211동 ",
                            link: "https://www.youtube.com/@%EA%B9%80%EC%A7%80%EC%97%B0-u1w",
                        },
                    ],
                },
                {
                    type: "아동돌봄",
                    children: [
                        {
                            name: "강남구8호점 자곡다함께키움센터",
                            tel: "02-2226-8978",
                            address: "서울시강남구자곡로 100 자곡문화센터 1층",
                            link: "https://blog.naver.com/jagokkium",
                        },
                        {
                            name: "강동구6호점 아이플러스키움센터",
                            tel: "02-488-5929",
                            address: "서울시 강동구 올림픽로 752, 3층",
                            link: "https://blog.naver.com/kdiplus21",
                        },
                        {
                            name: "관악구1호점 우리동네키움센터",
                            tel: "02-3285-1009",
                            address: "서울시 관악구 참숯5길 38, 1층",
                            link: "https://blog.naver.com/ga1kium",
                        },
                        {
                            name: "양천구5호점 우리동네키움센터",
                            tel: "070-8133-2463",
                            address: "서울시 양천구 신월로 24길 19, 4층",
                            link: "https://blog.naver.com/yc5kium",
                        },
                        {
                            name: "광진구9호점 우리동네키움센터",
                            tel: "02-455-7765",
                            address: "서울시 광진구 천호대로 716, 별관 1호",
                            link: "https://blog.naver.com/kwangjinkiwoom9",
                        },
                        {
                            name: "성남시다함께돌봄센터31호점\r\n(분당동어린이식당)",
                            tel: "031-701-0107",
                            address: "경기도 성남시 분당구 서현로421번길 7, 3층",
                            link: "https://blog.naver.com/sndadol31",
                        },
                    ],
                },
                {
                    type: "아동보호",
                    children: [
                        {
                            name: "경기광주아동보호전문기관",
                            tel: "031-8027-0171",
                            address: "경기도 광주시 행정타운로 64-2, 1층",
                            link: "http://www.gj-child.kr/",
                        },
                        {
                            name: "광명시아동보호전문기관",
                            tel: "02-897-1577",
                            address: "경기도 광명시 금하로 526,4층",
                            link: "https://gmcchild.cafe24.com/",
                        },
                        {
                            name: "성남시아동보호전문기관",
                            tel: "031-756-1391",
                            address: "경기도 성남시 수정구 복정로 96번길 30-1, 3층",
                            link: "http://www.snchild.co.kr/",
                        },
                        {
                            name: "파주시아동보호전문기관",
                            tel: "031-839-0940",
                            address: "경기도 파주시 금바위로 42, 운정법조타운 4층 407호",
                            link: "http://paju1391.kr/",
                        },
                        {
                            name: "꿈나래쉼터",
                            tel: "02-6673-3030",
                            address: "비공개시설",
                        },
                        {
                            name: "늘품쉼터",
                            tel: "031-282-3975",
                            address: "비공개시설",
                        },
                    ],
                },
                {
                    type: "중장년",
                    children: [
                        {
                            name: "강북50플러스센터",
                            tel: "02-986-5060",
                            address: "서울시 강북구 오현로 9길 49, 4층",
                            link: "https://50plus.or.kr/gbc/index.do",
                        },
                        {
                            name: "성북50플러스센터",
                            tel: "02-923-5060",
                            address: "서울시 성북구 지봉로 24길 26, 3-4층",
                            link: "https://50plus.or.kr/sbc/index.do",
                        },
                    ],
                },
                {
                    type: "노인",
                    children: [
                        {
                            name: "강북시니어클럽",
                            tel: "02-989-5001",
                            address: "서울시 강북구 오현로 9일 49, 1층",
                            link: "http://gangbuksc.or.kr/",
                        },
                        {
                            name: "광명시니어클럽",
                            tel: "02-2689-9842",
                            address: "경기도 광명시 연서일로4-3, 4층",
                            link: "https://gmsjob.co.kr",
                        },
                        {
                            name: "성북시니어클럽",
                            tel: "02-2135-9968",
                            address: "서울시 성북구 안암로 79, 1층",
                            link: "http://www.sbsc9988.or.kr/",
                        },
                        {
                            name: "양평시니어클럽",
                            tel: "031-775-9011",
                            address: "경기도 양평군 양평읍 중앙로 111번길 34-6, 1층",
                            // link: "",
                        },
                        {
                            name: "영등포시니어클럽",
                            tel: "02-833-7005",
                            address: "서울시 영등포구 영중로 119 리마크빌오피스텔 1층 109호",
                            link: "https://ydpsc.or.kr/",
                        },
                        {
                            name: "고양시덕양노인종합복지관",
                            tel: "031-969-7781",
                            address: "경기도 고양시 덕양구 어울림로 49",
                            link: "https://withnoin.org/",
                        },
                        {
                            name: "고양시치매노인주간보호센터",
                            tel: "031-979-9362",
                            address: "경기도 고양시 덕양구 용현로 42",
                            link: "https://gysilver.or.kr/",
                        },
                        {
                            name: "용인시기흥노인복지관",
                            tel: "031-284-8852",
                            address: "경기도 용인시 기흥구 산양로71, 1층",
                            link: "http://www.ygsenior.or.kr/",
                        },
                        {
                            name: "밝은내어르신복지센터",
                            tel: "02-2607-6088",
                            address: "서울시 양천구 지양로14길 17",
                            link: "https://www.bnsenior.org/",
                        },
                        {
                            name: "밝은내데이케어센터",
                            tel: "02-2602-4411",
                            address: "서울시 양천구 신월로 24길 19, 2층",
                            link: "https://cafe.daum.net/sinwc0623",
                        },
                    ],
                },
                {
                    type: "장애인",
                    children: [
                        {
                            name: "동탄어울림장애인주간보호센터",
                            tel: "070-8858-9267",
                            address: "경기도 화성시 동탄대로시범길 133",
                            link: "https://blog.naver.com/dtwith8500",
                        },
                    ],
                },
                {
                    type: "지역복지",
                    children: [
                        {
                            name: "강남지역자활센터",
                            tel: "02-445-1801",
                            address: "서울시 강남구 개포로38길 12",
                            link: "https://www.gangnam.go.kr/office/gjhope/main.do",
                        },
                        {
                            name: "화성시동탄어울림종합사회복지관",
                            tel: "031-376-5211",
                            address: "경기도 화성특례시 동탄대로시범길 133",
                            link: "http://dongtanwith.or.kr/",
                        },
                        {
                            name: "신월종합사회복지관",
                            tel: "02-2605-8728",
                            address: "서울시 양천구 신월로24길 19",
                            link: "http://www.sinwc.org/main/main.html",
                        },
                    ],
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.domestic-organization {
    > li {
        &:not(:last-child) {
            padding-bottom: 60px;
        }
    }
    &__child {
        min-height: 70px;
        padding: 16px;
        border-radius: 16px;
        display: flex;
        align-items: center;
    }
    &__name {
        font-weight: 700;
        white-space: pre-wrap;
        line-height: 1.35;
    }
    &__link {
        text-align: right;
    }
}
@media (min-width: 1024px) {
    .domestic-organization {
        > li {
            &:not(:last-child) {
                padding-bottom: 80px;
            }
        }
        &__child {
            border-radius: 999px;
            padding: 8px;
        }
        &__name,
        &__tel {
            text-align: center;
        }
        &__tel,
        &__link {
            position: relative;
        }
        &__tel {
            &::before,
            &::after {
                content: "";
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 24px;
                background-color: #ddd;
            }
            &::before {
                left: 0;
            }
            &::after {
                right: 0;
            }
        }
        &__address {
            padding-left: 24px;
            padding-right: 24px;
        }
        &__link {
            padding-left: 0;
            .v-btn {
                margin: 0 12px;
            }
            &::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                width: 1px;
                height: 24px;
                background-color: #ddd;
            }
        }
    }
}
</style>